export function setLocalStorage(data: string, key: string): void {
  const date: string = new Date().toISOString();
  const popupData: { data: string; date: string } = { data: data, date: date };
  localStorage.setItem(key, JSON.stringify(popupData));
}

export function getFromLocalStorage(key: string): { data: string; date: string } {
  const localStorageItem: string = localStorage.getItem(key);
  if (!localStorageItem) {
    return { data: '', date: '' };
  } else {
    return JSON.parse(localStorageItem) as { data: string; date: string };
  }
}

export function isMoreThanDaysAgo(date: Date, days: number): boolean {
  const daysAgo: Date = new Date();
  daysAgo.setDate(daysAgo.getDate() - days);
  return date < daysAgo;
}
